/** Bedarfsfinder (F7-39), Shop-Texte (de). */
export const storefrontNeedsDe = {
  title: 'Was mein Tier braucht',
  metaDescription:
    'Mit wenigen Fragen ein Vorschlag für die tägliche Pflegeroutine passend zu Tierart, Alter und Bedarf. Ersetzt keine tierärztliche Untersuchung.',
  lead: 'Beantworten Sie ein paar Fragen, und wir schlagen eine tägliche Pflegeroutine für Ihr Tier vor.',
  privacy: 'Ihre Antworten bleiben nur in diesem Browser; sie werden nicht an uns gesendet.',
  disclaimer: 'Dieser Vorschlag ersetzt keine tierärztliche Untersuchung.',
  start: 'Starten',
  steps: {
    species: 'Tierart',
    basics: 'Grunddaten',
    areas: 'Bereiche',
    questions: 'Fragen',
    result: 'Ergebnis',
  },
  progress: 'Fortschritt',
  stepOf: 'Schritt {{n}} von {{total}}',
  speciesQuestion: 'Welches Tier haben Sie?',
  basicsQuestion: 'Erzählen Sie uns etwas über Ihr Tier',
  age: 'Alter',
  ages: { baby: 'Jungtier', young: 'Jung', adult: 'Erwachsen', senior: 'Senior' },
  weight: 'Gewicht',
  weights: {
    under_2: 'Unter 2 kg',
    '2_5': '2–5 kg',
    '5_10': '5–10 kg',
    '10_25': '10–25 kg',
    over_25: 'Über 25 kg',
  },
  neutered: 'Kastriert?',
  neuteredOptions: { yes: 'Ja', no: 'Nein', unknown: 'Weiß ich nicht' },
  reproductive: 'Trächtig oder säugend?',
  reproductiveOptions: {
    none: 'Nein',
    pregnant: 'Trächtig',
    lactating: 'Säugend',
    unknown: 'Weiß ich nicht',
  },
  areasQuestion: 'Wobei suchen Sie Unterstützung?',
  multipleHint: 'Mehrfachauswahl möglich.',
  noAreas: 'Für diese Tierart sind noch keine Bereiche eingerichtet.',
  browseSpecies: 'Produkte für {{species}} ansehen',
  back: 'Zurück',
  next: 'Weiter',
  seeResult: 'Ergebnis ansehen',
  restart: 'Neu beginnen',
  change: 'Ändern',
  answerRequired: 'Treffen Sie eine Auswahl, um fortzufahren.',
  resultTitle: 'Vorgeschlagene Routine für Ihr Tier',
  resultLead: 'Wir schlagen {{count}} Produkte vor; Unerwünschtes können Sie herausnehmen.',
  why: 'Warum vorgeschlagen',
  usage: 'Anwendung',
  include: 'In der Routine',
  includeLabel: '{{name}} in der Routine',
  alternativeFor: 'Das vorgeschlagene Produkt ist nicht vorrätig, daher wird dieses angezeigt.',
  option: 'Variante: {{name}}',
  otherOptions: 'Weitere Varianten auf der Produktseite',
  total: 'Summe',
  totalNote: '{{count}} Produkte ausgewählt. Versand und Aktionen werden im Warenkorb berechnet.',
  addAll: 'Alle in den Warenkorb',
  adding: 'Wird hinzugefügt…',
  added: '{{count}} Produkte in den Warenkorb gelegt.',
  goCart: 'Zum Warenkorb',
  addFailed: '{{name}} konnte nicht hinzugefügt werden: {{error}}',
  nothingSelected: 'Wählen Sie mindestens ein Produkt aus.',
  empty: 'Wir haben keine passenden Produkte gefunden.',
  emptyLead: 'Wählen Sie einen anderen Bereich oder sehen Sie sich alle Produkte an.',
  browseAll: 'Alle Produkte ansehen',
  emergencyTitle: 'Bitte wenden Sie sich zuerst an eine Tierärztin oder einen Tierarzt',
  emergencyText:
    'Die gewählte Situation kann dringende Versorgung erfordern. In diesem Fall schlagen wir keine Produkte vor; bitte wenden Sie sich umgehend an eine Tierärztin oder einen Tierarzt.',
  emergencyLinks: 'Hilfreiche Seiten',
  emergencyBack: 'Antwort ändern',
  bundle: 'Für diese Routine gültige Aktion',
  answersTitle: 'Ihre Antworten',
  summary: {
    title: 'Routine im Überblick',
    empty: 'Vorschläge erscheinen hier, während Sie die Fragen beantworten.',
    show: 'Routine ansehen ({{count}})',
    pending: 'Offene Fragen: {{count}}',
  },
  chat: {
    greeting: 'Hallo! Mit ein paar kurzen Fragen stellen wir eine Pflegeroutine für Ihr Tier zusammen.',
    log: 'Fragen und Ihre Antworten',
    question: 'Frage',
    answer: 'Ihre Antwort',
    edit: 'Antwort ändern',
    resultIntro: 'Die Routine, die wir nach Ihren Antworten vorschlagen:',
    fixed: 'Diese Fragen sind fest vorgegeben und werden für alle nach denselben Regeln beantwortet.',
  },
  savePet: {
    title: 'Mein Tier speichern',
    lead: 'Speichern Sie die Grunddaten in Ihrem Konto, damit Sie sie nicht erneut eingeben müssen. Antworten auf Gesundheitsfragen werden nicht gespeichert.',
    name: 'Name Ihres Tieres',
    consent:
      'Ich willige ausdrücklich ein, dass Tierart, Alter, Gewichtsbereich, Kastrations- und Trächtigkeits-/Säugeangaben meines Tieres sowie die gewählten Bereiche in meinem Konto gespeichert und für Vorschläge verwendet werden. Ich kann diesen Eintrag jederzeit unter „Mein Konto“ löschen.',
    save: 'Mein Tier speichern',
    saved: 'Ihr Tier wurde gespeichert.',
    login: 'Zum Speichern anmelden',
  },
  pets: {
    title: 'Meine gespeicherten Tiere',
    lead: 'Grunddaten, die Sie im Bedarfsfinder mit Ihrer ausdrücklichen Einwilligung gespeichert haben.',
    use: 'Für {{name}} starten',
    unnamed: 'Mein Tier ({{species}})',
    delete: 'Löschen',
    deleteLabel: 'Eintrag {{name}} löschen',
    deleted: 'Eintrag gelöscht.',
    empty: 'Sie haben keine gespeicherten Tiere.',
    open: 'Bedarfsfinder öffnen',
  },
  seed: {
    reason: 'Für den gewählten Bereich „{{area}}“.',
    emergencyQuestion: 'Hat Ihr Tier gerade eines der folgenden Anzeichen?',
    emergencyHelp:
      'Dann schlagen wir keine Produkte vor; bitte wenden Sie sich zuerst an eine Tierärztin oder einen Tierarzt.',
    emergencyNone: 'Nichts davon',
    emergency: {
      breathing: 'Hat Atemnot',
      bleeding: 'Blutung, die nicht aufhört',
      poison: 'Könnte etwas Giftiges gefressen oder abgeleckt haben',
      seizure: 'Hat einen Krampfanfall',
      collapse: 'Ist zusammengebrochen oder kann nicht aufstehen',
      not_eating: 'Frisst oder trinkt seit über einem Tag gar nicht',
    },
    pregnancyNote: 'Im Warnhinweis des Produkts werden Trächtigkeit oder Säugen erwähnt.',
    intro:
      'Wählen Sie Tierart, Alter und die Themen, bei denen Sie Unterstützung suchen; wir schlagen eine passende tägliche Pflegeroutine vor.',
    emergencyText:
      'Die gewählte Situation kann dringende Versorgung erfordern. In diesem Fall schlagen wir keine Produkte vor; bitte wenden Sie sich umgehend an eine Tierärztin oder einen Tierarzt.',
  },
};
